module.exports = __webpack_public_path__ + "static/media/039.f64c9d7d.jpg";